const adjectives = [
  'Mystic', 'Ethereal', 'Dreamy', 'Crystal', 'Celestial',
  'Radiant', 'Luminous', 'Serene', 'Pristine', 'Enchanted',
  'Astral', 'Cosmic', 'Divine', 'Sublime', 'Majestic',
  'Velvet', 'Whispered', 'Infinite', 'Eternal', 'Glowing',
  'Shimmering', 'Iridescent', 'Ethereal', 'Floating', 'Dancing'
];

const nouns = [
  'Whisper', 'Dawn', 'Twilight', 'Aurora', 'Nebula',
  'Galaxy', 'Horizon', 'Cascade', 'Prism', 'Mirage',
  'Zenith', 'Echo', 'Essence', 'Aether', 'Harmony',
  'Breeze', 'River', 'Ocean', 'Mountain', 'Forest',
  'Valley', 'Storm', 'Cloud', 'Rain', 'Mist'
];

export function generateGradientName(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${adjective} ${noun}`;
}